import { render, staticRenderFns } from "./findPass.vue?vue&type=template&id=38d4d1d0&scoped=true"
import script from "./findPass.vue?vue&type=script&lang=js"
export * from "./findPass.vue?vue&type=script&lang=js"
import style0 from "./findPass.vue?vue&type=style&index=0&id=38d4d1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4d1d0",
  null
  
)

export default component.exports